module.exports = __webpack_public_path__ + "static/media/board.1765f653.png";